import React, { useState, useEffect } from 'react';
import S from './ScrollToTopButton.module.scss';

export const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <>
            {isVisible && (
                <button
                    className={S.button}
                    onClick={scrollToTop}
                    style={{
                        opacity: isVisible ? 1 : 0
                    }}
                >
                    ↑
                </button>
            )}
        </>
    );
};